import { Country } from "../models/country.model";

export const COUNTRIES: Country[] = [
  { label: "Afghanistan", value: "AF", code: "AFG" },
  { label: "Albania", value: "AL", code: "ALB" },
  { label: "Algeria", value: "DZ", code: "DZA" },
  { label: "Argentina", value: "AR", code: "ARG" },
  { label: "Armenia", value: "AM", code: "ARM" },
  { label: "Aruba", value: "AW", code: "ABW" },
  { label: "Australia", value: "AU", code: "AUS" },
  { label: "Austria", value: "AT", code: "AUT" },
  { label: "Azerbaijan", value: "AZ", code: "AZE" },
  { label: "Bahamas", value: "BS", code: "BHS" },
  { label: "Bahrain", value: "BH", code: "BHR" },
  { label: "Bangladesh", value: "BD", code: "BGD" },
  { label: "Barbados", value: "BB", code: "BRB" },
  { label: "Belarus", value: "BY", code: "BLR" },
  { label: "Belgium", value: "BE", code: "BEL" },
  { label: "Belize", value: "BZ", code: "BLZ" },
  { label: "Benin", value: "BJ", code: "BEN" },
  { label: "Bolivia", value: "BO", code: "BOL" },
  { label: "Bosnia and Herzegovina", value: "BA", code: "BIH" },
  { label: "Botswana", value: "BW", code: "BWA" },
  { label: "Brazil", value: "BR", code: "BRA" },
  { label: "Bulgaria", value: "BG", code: "BGR" },
  { label: "Cambodia", value: "KH", code: "KHM" },
  { label: "Cameroon", value: "CM", code: "CMR" },
  { label: "Canada", value: "CA", code: "CAN" },
  { label: "Cape Verde", value: "CV", code: "CPV" },
  { label: "Cayman Islands", value: "KY", code: "CYM" },
  { label: "Chile", value: "CL", code: "CHL" },
  { label: "China", value: "CN", code: "CHN" },
  { label: "Colombia", value: "CO", code: "COL" },
  { label: "Costa Rica", value: "CR", code: "CRI" },
  { label: "Croatia", value: "HR", code: "HRV" },
  { label: "Cuba", value: "CU", code: "CUB" },
  { label: "Curaçao", value: "CW", code: "CUW" },
  { label: "Cyprus", value: "CY", code: "CYP" },
  { label: "Czech Republic", value: "CZ", code: "CZE" },
  { label: "Denmark", value: "DK", code: "DNK" },
  { label: "Dominican Republic", value: "DO", code: "DOM" },
  { label: "Ecuador", value: "EC", code: "ECU" },
  { label: "Egypt", value: "EG", code: "EGY" },
  { label: "El Salvador", value: "SV", code: "SLV" },
  { label: "Estonia", value: "EE", code: "EST" },
  { label: "Ethiopia", value: "ET", code: "ETH" },
  { label: "Finland", value: "FI", code: "FIN" },
  { label: "France", value: "FR", code: "FRA" },
  { label: "Germany", value: "DE", code: "DEU" },
  { label: "Ghana", value: "GH", code: "GHA" },
  { label: "Greece", value: "GR", code: "GRC" },
  { label: "Grenada", value: "GD", code: "GRD" },
  { label: "Guatemala", value: "GT", code: "GTM" },
  { label: "Guyana", value: "GY", code: "GUY" },
  { label: "Haiti", value: "HT", code: "HTI" },
  { label: "Honduras", value: "HN", code: "HND" },
  { label: "Hungary", value: "HU", code: "HUN" },
  { label: "Iceland", value: "IS", code: "ISL" },
  { label: "India", value: "IN", code: "IND" },
  { label: "Indonesia", value: "ID", code: "IDN" },
  { label: "Iran", value: "IR", code: "IRN" },
  { label: "Iraq", value: "IQ", code: "IRQ" },
  { label: "Ireland", value: "IE", code: "IRL" },
  { label: "Israel", value: "IL", code: "ISR" },
  { label: "Italy", value: "IT", code: "ITA" },
  { label: "Jamaica", value: "JM", code: "JAM" },
  { label: "Japan", value: "JP", code: "JPN" },
  { label: "Jordan", value: "JO", code: "JOR" },
  { label: "Kazakhstan", value: "KZ", code: "KAZ" },
  { label: "Kenya", value: "KE", code: "KEN" },
  { label: "Kuwait", value: "KW", code: "KWT" },
  { label: "Latvia", value: "LV", code: "LVA" },
  { label: "Lebanon", value: "LB", code: "LBN" },
  { label: "Lithuania", value: "LT", code: "LTU" },
  { label: "Luxembourg", value: "LU", code: "LUX" },
  { label: "Malaysia", value: "MY", code: "MYS" },
  { label: "Malta", value: "MT", code: "MLT" },
  { label: "Mexico", value: "MX", code: "MEX" },
  { label: "Morocco", value: "MA", code: "MAR" },
  { label: "Netherlands", value: "NL", code: "NLD" },
  { label: "New Zealand", value: "NZ", code: "NZL" },
  { label: "Nicaragua", value: "NI", code: "NIC" },
  { label: "Nigeria", value: "NG", code: "NGA" },
  { label: "Norway", value: "NO", code: "NOR" },
  { label: "Pakistan", value: "PK", code: "PAK" },
  { label: "Panama", value: "PA", code: "PAN" },
  { label: "Paraguay", value: "PY", code: "PRY" },
  { label: "Peru", value: "PE", code: "PER" },
  { label: "Philippines", value: "PH", code: "PHL" },
  { label: "Poland", value: "PL", code: "POL" },
  { label: "Portugal", value: "PT", code: "PRT" },
  { label: "Puerto Rico", value: "PR", code: "PRI" },
  { label: "Qatar", value: "QA", code: "QAT" },
  { label: "Romania", value: "RO", code: "ROU" },
  { label: "Russia", value: "RU", code: "RUS" },
  { label: "Saudi Arabia", value: "SA", code: "SAU" },
  { label: "Senegal", value: "SN", code: "SEN" },
  { label: "Serbia", value: "RS", code: "SRB" },
  { label: "Singapore", value: "SG", code: "SGP" },
  { label: "Sint Maarten", value: "SX", code: "SXM" },
  { label: "Slovakia", value: "SK", code: "SVK" },
  { label: "Slovenia", value: "SI", code: "SVN" },
  { label: "South Africa", value: "ZA", code: "ZAF" },
  { label: "South Korea", value: "KR", code: "KOR" },
  { label: "Spain", value: "ES", code: "ESP" },
  { label: "Sri Lanka", value: "LK", code: "LKA" },
  { label: "Suriname", value: "SR", code: "SUR" },
  { label: "Sweden", value: "SE", code: "SWE" },
  { label: "Switzerland", value: "CH", code: "CHE" },
  { label: "Thailand", value: "TH", code: "THA" },
  { label: "Trinidad and Tobago", value: "TT", code: "TTO" },
  { label: "Tunisia", value: "TN", code: "TUN" },
  { label: "Turkey", value: "TR", code: "TUR" },
  { label: "Ukraine", value: "UA", code: "UKR" },
  { label: "United Arab Emirates", value: "AE", code: "ARE" },
  { label: "United Kingdom", value: "GB", code: "GBR" },
  { label: "United States", value: "US", code: "USA" },
  { label: "Uruguay", value: "UY", code: "URY" },
  { label: "Venezuela", value: "VE", code: "VEN" },
  { label: "Vietnam", value: "VN", code: "VNM" },
  { label: "Virgin Islands", value: "VI", code: "VIR" }
];

export function getCountryByCode(code: string): Country | undefined {
  return COUNTRIES.find(country => country.value === code || country.code === code);
}

export function getCountryByName(name: string): Country | undefined {
  return COUNTRIES.find(country => 
    country.label.toLowerCase().includes(name.toLowerCase())
  );
}

export function getCountryCodes(): string[] {
  return COUNTRIES.map(country => country.value);
}

export function getCountryNames(): string[] {
  return COUNTRIES.map(country => country.label);
} 